export const queryKeys = {
    marketInsights: (compsetId) => ["dashboard-market-insights", compsetId],
    competitiveAnalysis: (compsetId) => ["dashboard-competitive-analysis", compsetId],
    rateparity: (compsetId) => ["dashboard-rateparity", compsetId],
    advancedAnalytics: (compsetId) => ["dashboard-advanced-analytics", compsetId],
    officialSiteInfo: (compsetId) => ["rateparity-official-site-validation", compsetId],
    allAiInsights: (compsetId) => ["ai-insights", compsetId],
    demandEvents: (compsetId) => ["demand-and-events", compsetId],
    compsets: () => ["compsets"],
    runLogs: (currentPage) => ["run-logs", currentPage],
    me: () => ["profile-details"],
    schedules: () => ["schedules"],
    planDetails: () => ["plan-details"],
    analyticsKeys: (compsetId) => [
        queryKeys.marketInsights(compsetId),
        queryKeys.competitiveAnalysis(compsetId),
        queryKeys.rateparity(compsetId),
        queryKeys.advancedAnalytics(compsetId),
        queryKeys.compsets(compsetId),
        queryKeys.demandEvents(compsetId),
        queryKeys.runLogs(1),
    ],
    ipInfo: () => ["ip-info"],
    planRules: () => ["plan-rules"],
    paymentHistory: () => ["payment-history"],
    exportAnalyticsData: () => ["export-analytics-data"]
    // rateshopExecution : ()
}